import { useState } from "react";
import { dateObj } from "features/constants";
import styled from "styled-components";
import EventDetailsExample from "./EventDetailsExample";
import useImageLoader from "hooks/useImageLoader";
import EventMap from "components/events/singlePageEventComponents/EventMap";
import EventDiscussionExample from "./EventDiscussionExample";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function EventsExample() {
  const { t } = useTranslation("marketing");
  const [date, setDate] = useState(new Date("2025-10-06T04:00:00.000+00:00")); // ['detail', 'discussion'
  const [privacy, setPrivacy] = useState("");
  const [imageSource, { blur }] = useImageLoader(
    "https://praysely.blob.core.windows.net/event-images/137c1e87-650d-48ad-8470-4f88b2b719cd_thumb.png",
    `https://praysely.blob.core.windows.net/event-images/0786dfb8-7504-4c6e-a270-f201f85de134.png`,
  );
  const [contentView, setContentView] = useState("details"); // ['detail', 'discussion'
  const [coordinates, setCoordinates] = useState([
    "-82.40001579999999",
    "34.8484984",
  ]);

  const { eventRsvped, eventRsvpLoading } = useSelector(
    (state) => state.landingPage,
  );

  return (
    <SinglePageContainer>
      <SinglePageWrap addTopMargin={true}>
        <SinglePageLeft2>
          <ItemContainer>
            <img
              onContextMenu={(e) => e.preventDefault()}
              src={"praysely-picnic.png"}
              alt="event"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
              }}
            />
          </ItemContainer>

          <EventInfo>
            <ChurchInfo>
              <ChurchImage>
                <img
                  onContextMenu={(e) => e.preventDefault()}
                  src={`https://praysely.blob.core.windows.net/user-images/bc4d47b8-293d-4390-85ac-0a13bdd9d927.png`}
                  alt="event"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              </ChurchImage>
              <ChurchName>{t("demo.churchName")}</ChurchName>
            </ChurchInfo>

            <EventInfoWrap>
              <EventTitle>
                <p style={{ marginLeft: "10px" }}>{t("demo.eventName")}</p>
              </EventTitle>
              <EventDate>
                {date &&
                  ` ${dateObj.dayLong[date.getDay()]} ${dateObj.monthLong[date.getMonth()]}

                                            ${date.getDate()} ${date.getFullYear()}
                                    `}
              </EventDate>
            </EventInfoWrap>
          </EventInfo>

          <MapWrap>
            {coordinates && (
              <MapContainer style={{ height: "300px", position: "relative" }}>
                <OpenInGoogle
                  onClick={() =>
                    window.open(
                      `https://www.google.com/maps/search/?api=1&query=Charleston, SC, USA`,
                    )
                  }
                >
                  {t("demo.openMaps")}
                </OpenInGoogle>
                <EventMap
                  markerTitle={"Event Name"}
                  markerPosition={[32.7833163, -79.9319664]}
                />
              </MapContainer>
            )}
          </MapWrap>
        </SinglePageLeft2>
        <SinglePageRight2>
          <TopRightItemContainer>
            <SectionButton>
              <SectionButtonTitle
                active={contentView === "details"}
                onClick={() => setContentView("details")}
              >
                Details
              </SectionButtonTitle>
              <SectionButtonTitle
                disabled={privacy === "private"}
                active={contentView === "discussion"}
                onClick={() => setContentView("discussion")}
              >
                Discussion
              </SectionButtonTitle>
            </SectionButton>
          </TopRightItemContainer>

          <RightMainContent>
            {contentView === "details" ? (
              <EventDetailsExample attending={eventRsvped} />
            ) : (
              <EventDiscussionExample />
            )}
          </RightMainContent>
        </SinglePageRight2>
      </SinglePageWrap>
    </SinglePageContainer>
  );
}

const MapWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 300px;
  margin-top: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px #ccc;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const MapContainer = styled.div`
  position: relative;
  min-height: 200px;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d6d6d6;
`;

const OpenInGoogle = styled.button`
  position: absolute;
  top: 5px;
  border: 1px solid #b0b0b0;
  outline: none;
  border-radius: 3px;
  background-color: white;
  right: 5px;
  z-index: 999;
  color: #666666;
  padding: 5px;
  cursor: pointer;
  font-size: 11px;
`;

const SinglePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
`;
const SinglePageWrap = styled.div`
  display: flex;
  height: 325px;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-top: ${(props) => (props.addTopMargin ? "20px" : "0px")};
  overflow-y: scroll;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0px;
    height: 400px;
  }
`;
const SinglePageLeft2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  height: fit-content;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    height: fit-content;
  }
`;
const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 50%;
  background-color: white;
  @media (max-width: 768px) {
    height: 100%;
  }
`;
const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding: 10px;
  background-color: white;
  border-radius: 0px 0px 15px 15px;
  box-shadow: 0 0 10px #ccc;
  @media (max-width: 768px) {
    padding: 10px;
    height: 100%;
  }
`;
const EventInfoWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  height: fit-content;
  padding: 10px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const ChurchInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: fit-content;
  padding: 10px;
  border-bottom: 1px solid #ececec;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;
const ChurchImage = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;
const ChurchName = styled.div`
  font-size: 15px;
  color: var(--lightThemeSecondaryFontColor);
  font-weight: 500;
  padding: 10px;
  @media (max-width: 768px) {
    padding-left: 10px;
  }
`;

const EventTitle = styled.div`
  font-size: 17px;
  color: var(--lightThemeFontColor);
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const EventDate = styled.div`
  font-size: 12px;
  color: var(--lightThemeSecondaryFontColor);
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  @media (max-width: 768px) {
    padding: 5px;
  }
`;

const SinglePageRight2 = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 45%;
  padding: 0px 20px 10px 20px;
  /* border: 1px solid red; */
  @media (max-width: 768px) {
    padding: 5px;
    width: 100%;
  }
`;

const TopRightItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  box-shadow: 0 0 10px #ccc;
  width: 100%;
  height: fit-content;
  background-color: white;
`;

const SectionButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
`;
const SectionButtonTitle = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  pointer-events: ${(props) => (props.active || props.disabled ? "none" : "auto")};
  border-bottom: ${(props) => (props.active ? "3px solid var(--themeColor)" : "3px solid transparent")};
  color: var(--lightThemeFontColor);
  transition: all 0.4s;
  &:hover {
    border-radius: ${(props) => (props.active ? "none" : "10px")};
    background-color: #ececec;
    border-bottom: 3px solid transparent;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const RightMainContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  @media (max-width: 768px) {
    margin-top: 10px;
    height: fit-content;
  }
`;
